import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { NouisliderModule } from 'ng2-nouislider';
import { JwBootstrapSwitchNg2Module } from 'jw-bootstrap-switch-ng2';
import { RouterModule } from '@angular/router';

import { ComponentsComponent } from './components.component';
import { BannerComponent } from './banner/banner.component';
import { OfferComponent } from './offer/offer.component';
import { GalleryComponent } from './gallery/gallery.component';
import { PhotoGalleryModule } from '@twogate/ngx-photo-gallery';
import { NgxGalleryModule } from 'ngx-gallery-9';
import { AttractionsComponent } from './attractions/attractions.component';
import { AttractionCardComponent } from './attraction-card/attraction-card.component';
import { LocationComponent } from './location/location.component';
import { ContactComponent } from './contact/contact.component';
import { FooterComponent } from './footer/footer.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        NouisliderModule,
        RouterModule,
        JwBootstrapSwitchNg2Module,
        PhotoGalleryModule,
        NgxGalleryModule,
      ],
    declarations: [
        ComponentsComponent,
        BannerComponent,
        OfferComponent,
        GalleryComponent,
        AttractionsComponent,
        AttractionCardComponent,
        LocationComponent,
        ContactComponent,
        FooterComponent
    ],
    exports:[ ComponentsComponent ]
})
export class ComponentsModule { }
